import { Disclosure } from "@headlessui/react";
import NextLinkOrig from "next/link";
import { cn } from "~/lib/utils";
import { CRMForms } from "../Navbar/CRMForms";
import { Anchor } from "../Anchor";
import { RWA_URLS } from "~/consts";
import { Routes } from "~/routes";
import { NAV_GROUPS } from "./consts";
import { MobileNavGroup } from "./MobileNavGroup";
import { NavigationUserEvents } from "~/modules/analytics/events/navigation";
import { track } from "~/modules/analytics/track";
import { buttonVariants } from "../ui/button";

// // // //

export function MobileNav(props: { pathname: string; isLoggedIn: boolean }) {
    const { pathname, isLoggedIn } = props;

    return (
        <div className="gap-y-2 border-t max-h-screen h-screen overflow-y-scroll pb-24 hide-scrollbar">
            {NAV_GROUPS.map((g, index) => (
                <MobileNavGroup
                    key={g.key}
                    group={g}
                    activePathname={pathname}
                    index={index}
                />
            ))}

            <div className="px-2 border-t pt-4 mt-2">
                <div className="px-3 pb-2 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                    Solutions
                </div>
                <NextLinkOrig
                    href={Routes.salesPage}
                    legacyBehavior
                    prefetch={false}
                >
                    <Disclosure.Button
                        as="a"
                        className={cn(
                            "cursor-pointer block w-full border-l-4 border-transparent py-2 pl-3 pr-4 text-left text-slate-500 hover:bg-slate-50 hover:border-border hover:text-slate-800",
                        )}
                        onClick={() => {
                            track(NavigationUserEvents.internalLinkClick, {
                                href: Routes.salesPage,
                                label: "Mobile Nav - Solutions - Data Solutions",
                            });
                        }}
                    >
                        <span className="block text-base font-medium text-foreground">
                            Data API
                        </span>
                        <span className="mt-1 block text-xs font-light text-muted-foreground">
                            Flexible API to power trading, research, and
                            compliance
                        </span>
                    </Disclosure.Button>
                </NextLinkOrig>
                <Disclosure.Button
                    as="a"
                    href={RWA_URLS.directorySignUp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn(
                        "block w-full border-l-4 border-transparent py-2 pl-3 pr-4 text-left text-slate-500 hover:bg-slate-50 hover:border-border hover:text-slate-800",
                    )}
                    onClick={() => {
                        track(NavigationUserEvents.anchorClick, {
                            href: RWA_URLS.directorySignUp,
                            openInNewTab: true,
                            label: "Mobile Nav - Solutions - Issuer Solutions",
                        });
                    }}
                >
                    <span className="block text-base font-medium text-foreground">
                        Issuer Registration
                    </span>
                    <span className="mt-1 block text-xs font-light text-muted-foreground">
                        Register your assets to achieve broad distribution
                    </span>
                </Disclosure.Button>
            </div>

            {/* Add "We're Hiring" CTA */}
            <div className="px-2 border-t pt-4 mt-2">
                <Anchor
                    openInNewTab
                    href={RWA_URLS.careers}
                    analyticsLabel={NavigationUserEvents.weAreHiring}
                    className={buttonVariants({
                        variant: "primaryLight",
                        size: "xs",
                        className: "py-2 w-full rounded-full",
                    })}
                >
                    {`We're Hiring`}
                </Anchor>
            </div>

            {/* Add "Investor Platform" CRM Form */}
            <div className="p-2">
                <CRMForms
                    buttonClassName={buttonVariants({
                        variant: "orOperatorLight",
                        size: "xs",
                        className: "py-2 w-full rounded-full",
                    })}
                />
            </div>

            {/* Add "List Your Company" CTA */}
            <div className="px-2">
                <Anchor
                    openInNewTab
                    href={RWA_URLS.directorySignUp}
                    className={buttonVariants({
                        variant: "warningLight",
                        size: "xs",
                        className: "py-2 w-full rounded-full",
                    })}
                    analyticsLabel={
                        NavigationUserEvents.mobileNavDirectorySignUpClick
                    }
                >
                    Register Your Asset
                </Anchor>
            </div>

            {/* Add Login + Register links MobileNav */}
            {!isLoggedIn && (
                <div className="border-t pt-2 mt-4">
                    <NextLinkOrig
                        href={Routes.login}
                        legacyBehavior
                        prefetch={false}
                    >
                        <Disclosure.Button
                            as="a"
                            className={cn(
                                "block border-l-4 py-2 pl-3 pr-4 text-base",
                                {
                                    "border-blue-500 text-blue-700 bg-blue-50 cursor-pointer":
                                        pathname === Routes.login,
                                    "border-transparent text-slate-500 hover:bg-slate-50 hover:border-border hover:text-slate-800 cursor-default":
                                        pathname !== Routes.login,
                                },
                            )}
                        >
                            Log in
                        </Disclosure.Button>
                    </NextLinkOrig>

                    <NextLinkOrig
                        href={Routes.register}
                        legacyBehavior
                        prefetch={false}
                    >
                        <Disclosure.Button
                            as="a"
                            className={cn(
                                "block border-l-4 py-2 pl-3 pr-4 text-base",
                                {
                                    "border-blue-500 text-blue-700 bg-blue-50 cursor-pointer":
                                        pathname === Routes.register,
                                    "border-transparent text-slate-500 hover:bg-slate-50 hover:border-border hover:text-slate-800 cursor-default":
                                        pathname !== Routes.register,
                                },
                            )}
                        >
                            Sign up
                        </Disclosure.Button>
                    </NextLinkOrig>
                </div>
            )}
        </div>
    );
}
